import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionQueryOptions } from '@/features/auth/api';
import { AppShell } from '@/features/shell/app-shell';
import { ApiError } from '@/shared/api/errors';

/** Every signed-in page lives under this layout; anonymous visitors are sent to sign in. */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    try {
      // Cached session if present, otherwise fetched (replaces the deprecated ensureQueryData).
      await context.queryClient.query({ ...sessionQueryOptions, staleTime: 'static' });
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router redirects are thrown
        throw redirect({ to: '/login', search: { redirect: location.href } });
      }
      throw error;
    }
  },
  component: AppShell,
});
